import React from 'react';
import Loader from './Loader';

/**
 * LoadingScreen component wrapper around Loader variant="fullscreen"
 */
const LoadingScreen = ({ isDarkMode = false, loadingText = "Preparing your tasks..." }) => {
  return <Loader variant="fullscreen" isDarkMode={isDarkMode} text={loadingText} />;
};

export default LoadingScreen;
